export default __webpack_public_path__ + "static/media/arrow-right.a70d4ef3.svg";